import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuControlsOption} from '@Components/contextual-menu/components/contextual-menu-controls-option';
import {GroupHorizontalAlignment, GroupVeticalAlignment} from '@PosterWhiteboard/page/alignment.class';
import styles from './group-items-alignment-options.module.scss';
import {useShouldDisableGroupMovementOptions} from '@Hooks/poster-editor/useShouldDisableGroupMovementOptions';

enum OptionTypes {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export function GroupItemsAlignmentOptions(): ReactElement<any> {
  const isDisabled = useShouldDisableGroupMovementOptions();

  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  const applyVerticalAlignment = (option: GroupVeticalAlignment): void => {
    currentPage?.activeSelection?.alignment?.verticalAlignment(option);
  };

  const applyHorizontalAlignment = (option: GroupHorizontalAlignment): void => {
    currentPage?.activeSelection?.alignment?.horizontalAlignment(option);
  };

  const onClickHandler = (clickedId: string): void => {
    const type = clickedId.split('-')[0] as OptionTypes;
    const option = clickedId.split('-')[1];
    if (type === OptionTypes.VERTICAL) {
      applyVerticalAlignment(option as GroupVeticalAlignment);
      return;
    }

    applyHorizontalAlignment(option as GroupHorizontalAlignment);
  };

  return (
    <ContextualMenuControlsOption
      id="group-items-alignment-options"
      isCenterAligned
      onClick={onClickHandler}
      wrapItems
      containerClassName={styles.container}
      data={[
        {
          id: `${OptionTypes.HORIZONTAL}-${GroupHorizontalAlignment.LEFT}`,
          icon: 'icon-left-align-shapes',
          text: window.i18next.t('pmwjs_left'),
          className: styles.item,
          disabled: isDisabled,
        },
        {
          id: `${OptionTypes.HORIZONTAL}-${GroupHorizontalAlignment.CENTER}`,
          icon: 'icon-center-align-shapes',
          text: window.i18next.t('pmwjs_middle'),
          className: styles.item,
          disabled: isDisabled,
        },
        {
          id: `${OptionTypes.HORIZONTAL}-${GroupHorizontalAlignment.RIGHT}`,
          icon: 'icon-right-align-shapes',
          text: window.i18next.t('pmwjs_right'),
          className: styles.item,
          disabled: isDisabled,
        },
        {
          id: `${OptionTypes.VERTICAL}-${GroupVeticalAlignment.TOP}`,
          icon: 'icon-top-align-shapes',
          text: window.i18next.t('pmwjs_top'),
          className: styles.item,
          disabled: isDisabled,
        },
        {
          id: `${OptionTypes.VERTICAL}-${GroupVeticalAlignment.CENTER}`,
          icon: 'icon-middle-align-shapes',
          text: window.i18next.t('pmwjs_center'),
          className: styles.item,
          disabled: isDisabled,
        },
        {
          id: `${OptionTypes.VERTICAL}-${GroupVeticalAlignment.BOTTOM}`,
          icon: 'icon-bottom-align-shapes',
          text: window.i18next.t('pmwjs_bottom'),
          className: styles.item,
          disabled: isDisabled,
        },
      ]}
    />
  );
}
